const Development = () => import(/* webpackChunkName: "reviews-development" */ './components/Development.vue');
const ReviewsFormNew = () => import(/* webpackChunkName: "reviews-form-new" */ './components/forms/reviews-form/FormNewReview');

export const routes = [
	{
		name: 'dev',
		path: '/',
		component: Development
	},
	{
		name: 'ReviewsFormNew',
		path: '/reviews-form-new/v1',
		component: ReviewsFormNew,
		props: (route) => (
			{
				organisation: route.query.organisation,
				utm_source: route.query.utm_source,
				utm_medium: route.query.utm_medium,
				utm_campaign: route.query.utm_campaign,
				utm_term: route.query.utm_term,
				utm_content: route.query.utm_content
			}
		)
	}
];
